__turbopack_context__.v({
  "badge": "calendar-event-list-module__qj9u7G__badge",
});
